"use client"

import { useEffect, useRef } from "react"



export function TextGradient({
  colors,
  animationSpeed = 20,
  showBorder = false,
  className = "",
  children,
}) {
  const gradientRef = useRef(null)

  useEffect(() => {
    if (!gradientRef.current) return

    const element = gradientRef.current
    const gradientColors = colors.join(", ")
    
    element.style.backgroundImage = `linear-gradient(90deg, ${gradientColors})`
    element.style.backgroundSize = `${colors.length * 100}% 100%`
    element.style.animation = `gradient ${animationSpeed}s linear infinite`
  }, [colors, animationSpeed])

  return (
    <div
      ref={gradientRef}
      className={`
        bg-clip-text text-transparent bg-gradient-to-r
        ${showBorder ? "border border-gray-200" : ""}
        ${className}
      `}
      style={{
        WebkitBackgroundClip: "text",
      }}
    >
      {children}
    </div>
  )
}

